export enum ErrorCode {
  NotAuthorizedException = 'NotAuthorizedException',
}
